import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import store from "./redux/store";
import { ToastContainer } from "react-toastify";
import { routes } from "./utils/routes";
import { QueryClient, QueryClientProvider } from "react-query";
import GlobalNotificationHandler from "./components/GlobalNotificationHandler";

const router = createBrowserRouter(routes);

const TOKEN_EXPIRATION_TIME = 24 * 60 * 60 * 1000;

function checkTokenAtStartup() {
  const currentPath = window.location.pathname;
  const isPublicPath = ["/pr-admin/login", "/pr-admin/signup"].includes(
    currentPath
  );

  const token = localStorage.getItem("token");
  const tokenTime = localStorage.getItem("tokenTime");

  if ((!token || !tokenTime) && !isPublicPath) {
    window.location.href = "/pr-admin/login";
    return;
  }

  const currentTime = Date.now();
  const elapsedTime = currentTime - parseInt(tokenTime || "0");

  if (elapsedTime > TOKEN_EXPIRATION_TIME && !isPublicPath) {
    localStorage.removeItem("token");
    localStorage.removeItem("tokenTime");
    window.location.href = "/pr-admin/login";
  }

  if (token && isPublicPath) {
    window.location.href = "/pr-admin/dashboard";
  }
}

function App() {
  const queryClient = new QueryClient();

  useEffect(() => {
    checkTokenAtStartup();
  }, []);
  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <GlobalNotificationHandler />
          <RouterProvider router={router} />
        </Provider>
        <ToastContainer
          hideProgressBar={true}
          position="top-right"
          autoClose={3000}
        />
        {/* <PushNotification /> */}
      </QueryClientProvider>
    </React.StrictMode>
  );
}

export default App;
